import { createRoot, type Root } from "react-dom/client";
import Events from "../pages/Events/Events";
import "../index.css";
import "../pages/Events/Events.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;
  root = createRoot(element);
  root.render(<Events />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADEvents = { mount, unmount };

function boot() {
  const element = document.getElementById("events-root");
  if (element) mount(element);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
else boot();
